import { useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { Toaster } from '@/components/ui/Toaster';
import { quietSkippedViewTransitions } from '@/lib/view-transitions';
import { ConsentBar } from './ConsentBar';
import { CtaDock } from './CtaDock';
import { Footer } from './Footer';
import { Header } from './Header';
import { TestingStrip } from './TestingStrip';
import { RouteAnnouncer } from './RouteAnnouncer';
import { RouteProgress } from './RouteProgress';
import { ScrollToTop } from './ScrollToTop';
import { SkipLink } from './SkipLink';
import { ToTop } from './ToTop';

/**
 * The page frame shared by every route: skip link → header (banner) → `<main id="main">` → footer
 * (contentinfo), plus route progress, the route announcer (screen readers + focus), the consent bar,
 * the CTA dock, back-to-top and scroll restoration. `<main>` is programmatically focusable (`tabIndex={-1}`) so the
 * skip link and route changes can move focus to it.
 */
export function AppShell() {
  // A skipped page transition is not an error (lib/view-transitions.ts).
  useEffect(() => {
    quietSkippedViewTransitions();
  }, []);

  return (
    <div className="app">
      <SkipLink />
      <RouteProgress />
      <RouteAnnouncer />
      <TestingStrip />
      <Header />
      <main id="main" tabIndex={-1} className="app-main">
        <Outlet />
      </main>
      <Footer />
      <ConsentBar />
      <CtaDock />
      <ToTop />
      <Toaster />
      <ScrollRestoration />
      <ScrollToTop />
    </div>
  );
}
